<template>
  <el-menu
    :default-active="selectedBar"
    class="el-menu-vertical-demo"
    :class="cssPrefix"
    mode="horizontal"
  >
    <el-menu-item index="0">
      <img @click="redirect('home')" height="50" :src="imgSrc" alt="Logo" />
    </el-menu-item>
    <el-menu-item @click="redirect('home')" index="1">
      <i class="el-icon-menu"></i>
      <span>Notas</span>
    </el-menu-item>

    <el-menu-item @click="dialogVisible = true" index="2">
      <i class="el-icon-s-cooperation"></i>
      <span>{{ companyName }} - {{ computedFederalId }}</span>
    </el-menu-item>

    <el-menu-item @click="redirect('user')" index="3" v-if="isAdmin">
      <i class="el-icon-user-solid"></i>
      <span>Usuários</span>
    </el-menu-item>

    <el-menu-item @click="redirect('company')" index="4" v-if="isAdmin">
      <i class="el-icon-s-cooperation"></i>
      <span>Empresas</span>
    </el-menu-item>

    <el-submenu index="5" style="float: right">
      <template slot="title">
        <i class="el-icon-user"></i>
        <span>{{ username }}</span>
      </template>
      <el-menu-item index="2-1" @click="redirect('profile')"
        >Perfil</el-menu-item
      >
      <el-menu-item index="2-3" @click="logout()">Sair</el-menu-item>
    </el-submenu>
    <el-dialog title="Mudar Empresa" :visible.sync="dialogVisible" width="30%">
      <span>Selecione uma das empresas disponiveis</span>
      <el-select v-model="selectValue" placeholder="Select">
        <el-option
          v-for="item in companyTable"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="changeCompany">Confirmar</el-button>
      </span>
    </el-dialog>
  </el-menu>
</template>

<script>
import { UserTypeEnum, UserService } from "../services/users/user.services";
import { CompaniesService } from "../services/companies/companies.service";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "NavBar",
  data() {
    return {
      selectedBar: "",
      imgSrc: "",
      dialogVisible: false,
      username: "",
      companyTable: [],
      companyId: "",
      companyFederalId: "",
      companyName: "",
      selectValue: "",
      isAdmin: false,
      prefix: ""
    };
  },
  computed: {
    cssPrefix: function() {
      return this.prefix;
    },
    computedFederalId: function() {
      let v = this.companyFederalId.replace(/\D/g, "");
      v = v.replace(/^(\d{2})(\d)/, "$1.$2");
      v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
      v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
      v = v.replace(/(\d{4})(\d)/, "$1-$2");
      return v;
    }
  },
  methods: {
    ...mapActions("auth", ["logout", "actionCompanyId", "actionPrefixRoute"]),
    ...mapGetters("auth", ["getCompanyId", "getPrefixRoute"]),
    changeCompany: function() {
      const vm = this;
      vm.actionCompanyId(vm.selectValue)
        .then(() => {})
        .catch(() => {})
        .finally(() => vm.redirect(vm.$route.name));
    },
    changeLogo: function() {
      const vm = this;
      CompaniesService.getLogo({ companyId: vm.getCompanyId() })
        .then(response => {
          if (response.logo) {
            vm.imgSrc = `data:image/png;base64, ${response.logo}`;
          } else {
            vm.imgSrc = `data:image/png;base64, ${response.logo}`;
            // vm.imgSrc = new URL(
            //   "@/assets/logo_white.png",
            //   import.meta.url
            // ).href;
          }
        })
        .catch(error =>
          this.$message({
            type: "error",
            message: error
          })
        );
    },
    redirect: function(page, query) {
      const vm = this;
      const currentPage = vm.$route.name;

      if (currentPage === page) return vm.$router.go();

      return vm.$router.push({
        name: page,
        params: { prefix: vm.prefix },
        query
      });
    }
  },
  mounted() {
    const vm = this;
    if (!vm.$router.name) vm.selectedBar = "2";
    UserService.me()
      .then(response => {
        vm.username = response.user.contact;
        vm.isAdmin =
          response.user.type === UserTypeEnum.ADMIN ||
          response.user.type === UserTypeEnum.MASTER;
        vm.companyId = vm.getCompanyId();

        if (!vm.companyId) {
          vm.companyId = response.user.companies[0].id;
          vm.companyName = response.user.companies[0].companyName;
          vm.companyFederalId = response.user.companies[0].federalId;
          vm.actionCompanyId(response.user.companies[0].id);
        }

        vm.companyTable = response.user.companies.map(value => {
          if (vm.companyId === value.id) {
            vm.companyFederalId = value.federalId;
            vm.companyName = value.companyName;
            vm.prefix = value.prefix;
          }

          return {
            value: value.id,
            label: `${value.companyName} - ${value.federalId}`
          };
        });
        vm.changeLogo();
        const prefixFromStore = vm.getPrefixRoute();
        if (
          prefixFromStore !== vm.prefix ||
          vm.$route.params.prefix !== vm.prefix
        ) {
          vm.actionPrefixRoute(vm.prefix);
          return vm.$router.push({
            name: vm.$route.name,
            params: { prefix: vm.prefix }
          });
        }
      })
      .catch(() => {
        vm.logout();
        vm.$router.push({ name: "login" });
      });
  }
};
</script>

<style></style>
